<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="topic-picker-content" v-loading="loading" element-loading-text="Loading...">
    <div class="div-select-section">
      <div class="div-header">
        <div class="div-search-input">
          <el-input v-model="searchInput" prefix-icon="el-icon-search" @keypress.enter.native="searchTopic"></el-input>
        </div>
        <div class="div-buttons">
          <el-button @click="handleCheckAllChange" :disabled="isCheckAll">Select all</el-button>
          <el-button @click="handleUnCheckAllChange" :disabled="isUnCheckAll">Deselect all</el-button>
        </div>
      <div class="div-add-btn"> 
        <el-button @click="addItems" class="add-btn" :disabled="isChecked" icon="el-icon-plus">Add</el-button>
      </div>
      </div>
      <div v-if="unselectedTopicList && unselectedTopicList.length > 0" class="div-select-topic-content">
        <div>
          <el-checkbox-group v-model="checkedTopics">
            <el-checkbox v-for="topic in unselectedTopicList" :title="topic.label" :label="topic.key" :key="topic.key" class="div-item">{{topic.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div v-else class="div-select-topic-content">
        <div class="no-result-message">{{$t('noDataFoundWithSearchOrFilter.message2')}}</div>
      </div>
    </div>
    <div class="div-selected-topic-section">
      <div class="div-header">
        <div class="header-title">Conversation Topics to Compare</div>
        <el-button class="btn-remove-all" @click="handleRemovekAll" :disabled="isRemoveAll">Clear all</el-button>
      </div>
      <div class="div-selected-topic-content" >
        <div v-if="selectedTopicList.length==0" class="no-topic-content">No Conversation Topics to compare</div>
        <div v-if="selectedTopicList.length==0" class="parent">
          <div class="no-topic-icon"></div>
        </div>
        <div v-if="selectedTopicList.length==0" class="no-topic-desc">Conversation Topics you add will be shown here. <br> <br> Add topics using the + button above.</div>
        <div v-else>
          <div class="div-item" :title="showTopicDisplay(topic)" v-for="(topic, index) in selectedTopicList" :key="topic">
            <div>{{showTopicDisplay(topic)}}</div><i class="el-icon-error" @click="removeTopic(index)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions} from 'vuex';

export default Vue.extend({
  name: 'wy-analytics-compare-metrics',
  props: ['parent', 'dataList'],

  data() {
    return {
      loading: false,
      searchInput: '',
      searchType: 'topicName',
      topicList: [],
      topicListOriginal: [],
      checkedTopics: [],
      selectedTopicList: [],
      searchOption: 'topicNames',
      searchOptions: [
        {
          value: 'topicNames',
          label: 'Conversation Topics'
        }
      ]
    }
  },

  watch: {
    searchInput(value) {
      if(this.searchOption == 'topicNames' || value.trim() == ''){
        this.searchTopic();
      }
    },
    searchOption() {
      this.searchTopic();
    },
    selectedTopicList(topics) {
      let selectedTopics = this.topicListOriginal.filter(el => topics.includes(el.key));
      this.parent.updateSelectedTopics(selectedTopics);      
    }
  },

  computed: {
    unselectedTopicList() {
      return this.topicList.filter(el => !this.selectedTopicList.includes(el.key));
    },
    isChecked() {
      return this.checkedTopics.length == 0;
    },

    isCheckAll() {
      let allChecked = true;
      this.unselectedTopicList.forEach(topic => {
        if(!this.checkedTopics.includes(topic.label)){
          allChecked = false;
        }
      })
      return allChecked;
    },
    isUnCheckAll() {
      let allUnChecked = true;
      this.unselectedTopicList.forEach(topic => {
        if(this.checkedTopics.includes(topic.label)){
          allUnChecked = false;
        }
      })
      return allUnChecked;
    },
    isRemoveAll() {
      return this.selectedTopicList.length == 0;
    }
  },

  methods: {
    ...mapActions(['fetchChatTopics']),

    // parsedLabel(label) {
    //   return (label.length > 35) ? label.substring(0, 35) + "..." : label;
    // },

    showTopicDisplay(topicKey) {
      let topicLabel = topicKey;
      this.topicListOriginal.forEach(topic=>{
        if(topic.key === topicKey) {
          topicLabel = topic.label;
        }
      })
      return topicLabel;
    },

    removeTopic(index) {
      this.selectedTopicList.splice(index, 1);
      this.searchTopic();
    },

    handleCheckAllChange() {
      if(this.searchInput == ''){
        this.checkedTopics = this.unselectedTopicList.map(el => el.key);
      }
      else{
        this.unselectedTopicList.forEach(topic => {
          if(!this.checkedTopics.includes(topic.label)){
            this.checkedTopics.push(topic.label)
          }
        })
      }
    },

    handleUnCheckAllChange() {
      if(this.searchInput == ''){
        this.checkedTopics = [];
      }
      else{
        this.unselectedTopicList.forEach(topic => {
          if(this.checkedTopics.includes(topic.label)){
            let index = this.checkedTopics.indexOf(topic.label)
            this.checkedTopics.splice(index, 1)
          }
        })
      }
    },

    handleRemovekAll() {
      this.selectedTopicList = [];
      this.searchTopic();
    },

    addItems() {
      if(this.checkedTopics.length > 0) {
        this.checkedTopics.forEach(topic => {
          this.selectedTopicList.push(topic);
        });        
        this.checkedTopics = [];
      }
    },

    async searchTopic() {
      if(this.searchInput == '') {
        this.topicList = JSON.parse(JSON.stringify(this.topicListOriginal));
      }
      else if(this.searchOption == 'topicNames') {
        let list = JSON.parse(JSON.stringify(this.topicListOriginal));
        this.topicList = list.filter(topic => topic.label.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
      }
    },
  },

  created() {  
    this.topicListOriginal = this.dataList;
    this.topicList = JSON.parse(JSON.stringify(this.dataList));
    if(this.parent.selecteTopicList) {
      let filterTopicKeys = this.parent.selecteTopicList.map(el => el.key);
      this.selectedTopicList = this.topicListOriginal.filter(el => filterTopicKeys.includes(el.key)).map(el => el.key);
    }
    else{
      this.handleUnCheckAllChange();
    }  
  }
});
</script>

<style lang="scss">
.topic-picker-content {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px 7px 12px;
  margin-top: 14px;
  background: transparent linear-gradient(180deg, #F2F2F2 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  .div-select-section {
    width: 70%;
    display: inline-block;
    vertical-align: top;
    .div-header {
      .div-search-input {
        width: 300px;
        height: 30px;
        display: inline-block;
        margin-right: 10px;
        input.el-input__inner {
          border-width: 0px 0px 0px 0px !important;
          // border-bottom-left-radius: 20px;
          // border-top-left-radius: 20px;
          border-radius: 20px;
          height: 30px;
          font-size: 11px;
        }
        .el-input__icon {
          line-height: 25px;
          font-weight: bolder;
          background-image: url('../../assets/icons/icon_search.svg');
          background-repeat: no-repeat;
          background-size: 16px 16px;
          background-position-y: 8px;
          background-position-x: 5px;
        }
        .el-input__icon:before {
          content: '';
        }
      }
      .div-search-dropdown {
        margin-right: 10px;
        display: inline-block;
        input.el-input__inner {
          border-width: 0 0 0 0!important;
          border-bottom-right-radius: 20px;
          border-top-right-radius: 20px;
          height: 30px;
          font-size: 14px;
          padding: 10px;
          width: fit-content;
          padding-bottom: 13px;
        }
        .el-input__icon {
          line-height: unset;
        }
        
      }
      .div-buttons {
        height: 30px;
        width: 215px;
        display: inline;
        .el-button {
          padding: 4px 20px 5px 20px;
          font-size: 11px;
          height: 30px;
          border-radius: 30px;
        }
        .el-button [class*=el-icon-]+span {
          margin-left: 1px;
        }

        button.el-button.el-button--default.is-disabled {
          background-color: #fff !important;
          color: #C0C4CC !important;
          font-weight: 400 !important;
          border-color: #ffffff;
          opacity: 0.5;
        }

        .add-btn {
          background-color: #214586;
          color: #FFF;
          font-weight: 600;
          margin-left: 130px;
        }
        .add-btn:hover {
          color: #FFF !important;
          background-color: #214586 !important;
        }

        button.el-button.add-btn.el-button--default.is-disabled {
          background-color: #fff !important;
          color: #C0C4CC !important;
          font-weight: 400 !important;
          border-color: #ffffff;
          opacity: 0.5;
        }

        .el-button:hover {
          color: #214586;
          border-color: #214586;
          background-color: #ffffff;
        }
      }
      .div-add-btn{
        float: right;
        .el-button {
          padding: 4px 20px 5px 20px;
          font-size: 11px;
          height: 30px;
          border-radius: 30px;
          margin-left: 6px;
        }
        .el-button [class*=el-icon-]+span {
          margin-left: 1px;
        }

        button.el-button.el-button--default.is-disabled {
          background-color: #fff !important;
          color: #C0C4CC !important;
          font-weight: 400 !important;
          border-color: #ffffff;
          opacity: 0.5;
        }

        .add-btn {
          background-color: #214586;
          color: #FFF;
          font-weight: 600;
          margin-right: 13px;
        }
        .add-btn:hover {
          color: #FFF !important;
          background-color: #214586 !important;
        }

        button.el-button.add-btn.el-button--default.is-disabled {
          background-color: #fff !important;
          color: #C0C4CC !important;
          font-weight: 400 !important;
          border-color: #ffffff;
          opacity: 0.5;
        }

        .el-button:hover {
          color: #214586;
          border-color: #214586;
          background-color: #ffffff;
        }
      }
    }
    .div-select-topic-content {
      height: 370px;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #FFF;
      padding: 7px 0px 7px 15px;
      margin-right: 10px;
      margin-top: 10px;
      border-radius: 10px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 8px;
      opacity: 1;
      .no-result-message{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 16%;
      }
      .el-checkbox {
        margin-right: 0px;
        color: #002852;
        .el-checkbox__inner {
          top: 1px;
          width: 15px;
          height: 15px;
        }
        .el-checkbox__inner::after {
          top: 1px;
          left: 4px
        }
      }
      .div-item {
        width: 230px;
        float: left;
        color: #002852;
        padding: 5px;
      }
      .el-checkbox__label {
        font-size: 13px;
        color: #002852;
        width: 88%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
    }
  }
  .div-selected-topic-section {
    width: 30%;
    display: inline-block;

    .div-header {
      height: 30px;
      text-align: center;
      padding-left: 0%;

      .header-title{
        margin-top: 6px;
        font-weight: 500;
        font-size: 14px;
        display: inline-block;
        color: #002852;
      }
      
      .btn-remove-all{
        padding: 4px 10px 5px 10px;
        font-size: 11px;
        height: 30px;
        border-radius: 30px;
        float: right;
      }

      .btn-remove-all:hover {
        color: #214586;
        border-color: #214586;
        background-color: #ffffff;
      }

      button.el-button.btn-remove-all.el-button--default.is-disabled {
          background-color: #fff !important;
          color: #C0C4CC !important;
          font-weight: 400 !important;
          border-color: #ffffff;
          opacity: 0.5;
      }

    }
    .div-selected-topic-content {
      height: 370px;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #FFF;
      padding: 7px 0px 7px 0px;
      margin-top: 10px;
      border-radius: 10px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 8px;
      opacity: 1;

      .div-item {
        color: #002852;
        font-weight: normal;
        font-size: 13px;
        line-height: 24px;
        padding-left: 15px;
        padding-top: 6px;
        div {
          display: inline-block;
          width: 88%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 15px;
        }
      }
      .div-item:hover {
        background: #E2ECF7;
      }

      .el-icon-error{
        float: right;
        display: none;
        font-size: 15px;
        top: 2px;
        left: -10px;
        position: relative;
        color: #80A6CD;
        cursor: pointer;
      }
      .el-icon-error.is-disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
      .div-item:hover .el-icon-error {
        display: block; 
      }
      .no-topic-content {
        font-size: 15px;
        text-align: center;
        margin-top: 50px;
        padding: 3px 10px 3px 10px;
        font-weight: 500;
        color: #636363;
      }
      .parent {
        width:100%;
        text-align: center;

        .no-topic-icon {
          display: inline-block;
          background-image: url('../../assets/icons/icon_empty_state.svg');
          height: 90px;
          background-repeat: no-repeat;
          background-size: 75%;
          background-position: 11px 14px;
          width: 90px;
        }
      } 
      
      .no-topic-desc {
        font-size: 15px;
        text-align: center;
        margin-top: 20px;
        padding: 3px 70px 3px 70px;
        font-weight: 400;
        color: #636363;
      }
    }
  }

  .el-loading-mask {
    height: auto !important;
    right: -10px;
    bottom: -10px;
  }
}
.el-select-dropdown.topic-picker-dropdown {
  .el-select-dropdown__item {
    font-size: 11px;
  }
  .el-scrollbar__wrap {
    display: block !important;
  }
}
.el-select-dropdown__item.selected {
    color: #214586;
    font-weight: 700;
}
</style>